export const setButtonBackgroundColor = (item) => {
  switch (item) {
    case "Pending Crawl":
      return "dark-purpal";

    case "Matched":
      return "primary";

    case "Unmatched":
      return "danger";

    default:
      return "default";
  }
};

export const changeDataFormat = (date) => {
  const crawlerDateTime = `${date}`;
  const dateObj = new Date(crawlerDateTime);

  const options = { month: "short", day: "2-digit", year: "numeric" };
  const formattedDateTime = dateObj.toLocaleDateString("en-US", options);
  return formattedDateTime;
};

export const getPriceValidity = (scrapedAt, validityThreshold = 7) => {
  if (!scrapedAt) return { isValid: "No", days: "N/A" };

  // Get current date in Los Angeles timezone
  const laNow = new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" });
  const today = new Date(laNow);
  const scrapedDate = new Date(scrapedAt);

  // Calculate difference in days
  const diffTime = today - scrapedDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  // Validity threshold is passed or defaults to 7 days.
  // We show remaining validity (e.g., if 2 days old, 5 days left -> +5 days)
  // If > threshold days old, it's negative (e.g., 10 days old -> -3 days)
  const validityDays = validityThreshold - diffDays;

  return {
    // Show "No" for negative validity (outdated), "Yes" for positive or zero (valid)
    isValid: validityDays >= 0 ? "Yes" : "No",
    days: validityDays >= 0 ? `+${validityDays} days` : `${validityDays} days`
  };
};
